import Layout from "../Layouts/Index";
import BoxHeader from "../components/BoxHeader";
import React, {useState} from "react";
import Accordion from "../components/Accordion";
import {careersClient} from "../Services/Prismic";
import Prismic from "@prismicio/client";
import LoadingDiv from "../components/Loading";
import NoData from "../components/NoData";
import { formatFullDate } from "../Assets/StaticContents/helpers";
import { RichText } from 'prismic-reactjs';

const Careers = () => {
    const [careers, setCareers] = React.useState([])
    const [isLoading, setIsLoading] = React.useState(true)
    const pageString = (new URLSearchParams(window.location.search)).get("page") || 1

    const [showPanel, setShowPanel] = useState(null)


    React.useEffect(() => {
        const fetchData = async () => {
            const response = await careersClient.query(
                Prismic.Predicates.at('document.type', 'careers'),
                { pageSize : 100, page : pageString, orderings : '[document.last_publication_date desc]' },
            )
            if (response) {
                // return console.log(response)
                setCareers(response.results)
                setIsLoading(false)
            }
        }
        fetchData()
    }, [pageString])

    const career_lists = careers.map((career, key) => {
        return (
            <Accordion
                label={RichText.render(career.data.title)}
                isActive={key === showPanel}
                handleClick={() => setShowPanel(key === showPanel ? null : key)}
                key={key}
            >
                <div>
                    <div className="text-xl mb-2">
                        {RichText.render(career.data.description)}
                    </div>
                    <div className="text-sm flex space-x-1 pt-4">
                        <span className="font-bold">created at:</span>
                        <span className="underline">{formatFullDate(career.first_publication_date)}</span>
                    </div>
                </div>
            </Accordion>
        )
    });

    return (
        <Layout>
            <div className="px-2 sm:px-4 md:px-10 lg:px-16 py-4">
                <BoxHeader text="" title="Vacancy at Parizzo" />
            </div>

            <div className="px-2 sm:px-4 md:px-12 lg:px-20 xl:px-32 py-4">
                <div className="w-full max-w-3xl mx-auto text-center py-10">
                    <div className="relative text-gray-700">
                        <h1 className="text-lg sm:text-2xl font-semibold uppercase">Available Positions</h1>
                        <div className="w-48 border-b border-gray-300 mx-auto mt-2 mb-4"></div>
                    </div>
                </div>

                <div className="w-full">
                    <div className="mx-auto">
                        <div className="grid grid-cols-1 my-4 lg:grid-cols-2">
                            <div className="my-auto">
                                <p className="font-normal text-md text-gray-700">
                                    <span>Available Positions</span>
                                    <span>({careers.length})</span>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mx-auto mb-16">
                    {isLoading ? <LoadingDiv></LoadingDiv> :
                        <div>
                            {careers.length > 0 ?
                                <dl className="mt-6">
                                    {career_lists}
                                </dl>
                                :
                                <NoData text="No Careers Available."/>
                            }
                        </div>
                    }
                </div>
            </div>
        </Layout>
    )
}

export default Careers;